<template>
  <modal :show.sync="showModal">
    <h6 slot="header" class="modal-title" id="modal-title-default">
      You have {{user.exclusiveCreditCount}} credits available.
      <small
        class="mt-2 d-block"
      >You will have {{user.exclusiveCreditCount >= 1 ? user.exclusiveCreditCount - 1 : 0}} credits after claiming this image.</small>
    </h6>
    <base-button
      :loading="loading"
      @click="claim"
      block
      type="primary"
      class="mb-1"
    >CLAIM THIS IMAGE</base-button>
    <img
      class="claim-thumbnail"
      :src="lastLookedAtPhotoUrl"
      :alt="'Art Grab claim image' + lastLookedAtPhotoID"
    />
  </modal>
</template>

<script>
import { mapState } from "vuex";
import swal from "sweetalert2";
const apiBaseURL = process.env.VUE_APP_API_URL;

export default {
  name: "claim-image",
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapState(["lastLookedAtPhotoID", "lastLookedAtPhotoUrl", "user"]),
    showModal: {
      get() {
        return this.$store.state.showClaimModal;
      },
      set(value) {
        this.$store.commit("showClaimModal", false);
      }
    }
  },
  methods: {
    showSuccessAlert() {
      swal.fire({
        type: "success",
        title: "Success!",
        text: "Image has been claimed.",
        confirmButtonColor: "#000",
        onClose: this.closeModal
      });
    },
    showErrorAlert(message) {
      swal.fire({
        type: "error",
        title: "Oh no!",
        text: message,
        confirmButtonColor: "#000"
      });
    },
    closeModal() {
      this.showModal = false;
      this.$router.push({ path: "/myimages" });
    },
    claim() {
      this.loading = true;
      this.axios
        .post(`${apiBaseURL}/api/artv1.1/photo/claim`, {
          id: this.lastLookedAtPhotoID
        })
        .then(result => {
          if (result.data.error_code == 0 && result.data.message == "Success") {
            if (result.data.data.message == "Success") {
              this.$store.commit("user", {
                exclusiveCreditCount: result.data.data.exclusive_credit_count,
                nonexclusiveCreditCount:
                  result.data.data.nonexclusive_credit_count
              });
              this.showSuccessAlert();
            } else {
              this.showErrorAlert(
                "We're sorry. There was an error claiming this image. Please try again."
              );
            }
          } else {
            this.showErrorAlert(
              "We're sorry. There was an error claiming this image. Please try again."
            );
          }
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.showErrorAlert(
            `We're sorry. There was an error claiming this image. Please try again. Error: ${error}`
          );
        });
    }
  }
};
</script>

<style lang="scss">
.claim-thumbnail {
  max-width: 100%;
  height: auto;
}

.modal-body {
  padding-top: 0;
}
</style>
